export default __webpack_public_path__ + "static/media/cash prize.0422f39d.svg";